import { Injectable } from '@angular/core';

// Libraries
import Swal, { SweetAlertOptions } from 'sweetalert2';

// Services
import { CreateAccountCaseService } from '../create-account-case.service';

// Configs
import { LOGIN_ERROR_MESSAGES_CONSTANT } from './configs';
@Injectable({
  providedIn: 'root',
})
export class LoginMessagesService {
  constructor(private readonly createAccountCaseService: CreateAccountCaseService) {}

  public showPopup(errorCode: string, errorMessage: string): void {
    const getAlertConfiguration = this.createAlert(errorCode, errorMessage);
    Swal.fire(getAlertConfiguration.options).then((result) => {
      getAlertConfiguration.fn(result);
    });
  }

  public createAlert(errorCode: string, errorMessage: string): { options: SweetAlertOptions; fn: Function } {
    const customClass = {
      popup: 'sweet-customized-popup',
      actions: 'sweet-customized-actions',
      confirmButton: 'mat-flat-button mat-primary',
      cancelButton: 'mat-flat-button mat-accent',
    };
    const confirmButtonColor = '#DA0916';

    let messageOptions = this.getMessagesOptionsByCode(errorCode, errorMessage);

    return {
      options: {
        showCancelButton: true,
        customClass: customClass,
        reverseButtons: true,
        allowOutsideClick: false,
        confirmButtonColor: confirmButtonColor,
        ...messageOptions.options,
      },
      fn: messageOptions.fn,
    };
  }

  public getMessagesOptionsByCode(code: string, errorMessage: string): { options: SweetAlertOptions; fn: Function } {
    const redirectToChangePassword = (result: { value: string }) => {
      this.returnToChangePassword(result);
    };

    const messages = {
      [LOGIN_ERROR_MESSAGES_CONSTANT.CODES.V_31]: {
        options: {
          title: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.UPS_CONST_TEXT,
          confirmButtonText: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.TRY_AGAIN_TEXT,
          cancelButtonText: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.REGISTER_NOW_TEXT,
          text: errorMessage,
        },
        fn: (result: { dismiss: Swal.DismissReason }) => {
          if (result.dismiss) {
            this.createAccountCaseService.execute();
          }
        },
      },
      [LOGIN_ERROR_MESSAGES_CONSTANT.CODES.S_70]: {
        options: {
          title: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.UPS_CONST_TEXT,
          confirmButtonText: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.TRY_AGAIN_TEXT,
          cancelButtonText: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.CHANGE_PASSWORD_TEXT,
          text: errorMessage,
        },
        fn: (result: { dismiss: Swal.DismissReason }) => {
          if (result.dismiss) {
            window.location.href = '/changePassword';
          }
        },
      },
      [LOGIN_ERROR_MESSAGES_CONSTANT.CODES.S_35]: {
        options: {
          title: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.UPS_CONST_TEXT,
          showCancelButton: false,
          reverseButtons: false,
          text: errorMessage,
        },
        fn: null,
      },
      [LOGIN_ERROR_MESSAGES_CONSTANT.CODES.S_97]: {
        options: {
          confirmButtonText: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.RETURN_TEXT,
          html: this.getPasswordLockedTimeRemaining(errorMessage),
          showCancelButton: false,
        },
        fn: null,
      },
      [LOGIN_ERROR_MESSAGES_CONSTANT.CODES.V_190]: {
        options: {
          confirmButtonText: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.CHANGE_PASSWORD_TEXT,
          cancelButtonText: LOGIN_ERROR_MESSAGES_CONSTANT.MESSAGES.TRY_AGAIN_TEXT,
          html: this.getPasswordLockedTimeRemaining(errorMessage),
        },
        fn: redirectToChangePassword,
      },
    };

    return messages[code];
  }
  public getPasswordLockedTimeRemaining(errorMessage: string): string {
    const messages = errorMessage.split(/[{}]/);
    const result = messages.map((p) => p.trim()).filter((p) => p);

    if (result.length > 1) {
      result[1] = `<br><br><span style="color: #666666; font-size: 16px;">${result[1]}</span>`;
    }
    return result.join('');
  }

  public returnToChangePassword(result: { value: string }): void {
    if (result.value) {
      window.location.href = '/changePassword';
    }
  }
}
